import * as CONSTRUCTOR from '../../generate';

export const fetchBookingDetailsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'FetchBookingDetailsResponse',
  fields: '{ body }',
});

export const fetchBookingListResponse = CONSTRUCTOR.FRAGMENT({
  name: 'FetchBookingListResponse',
  fields: '{ body }',
});

export const fetchUnitBookingResponse = CONSTRUCTOR.FRAGMENT({
  name: 'FetchUnitBookingResponse',
  fields: '{ body }',
});

export const fetchBookingHistoryResponse = CONSTRUCTOR.FRAGMENT({
  name: 'FetchBookingHistoryResponse',
  fields: '{ body }',
});
